var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"epc-table",class:{
    'text-body4': _vm.$mq === 'xl' || _vm.$mq === 'l',
    'text-body6': _vm.$mq === 'm',
    'text-body7': _vm.$mq === 's'
  }},_vm._l((_vm.table),function(row,rowIndex){return _c('tr',{key:rowIndex,staticClass:"epc-table-row",class:{
      'header-row': rowIndex === 0,
      'text-caption2':
        rowIndex === 0 && (_vm.$mq === 'xl' || _vm.$mq === 'l' || _vm.$mq === 'm'),
      'text-caption3': rowIndex === 0 && _vm.$mq === 's'
    }},_vm._l((row),function(cell,cellIndex){return _c('td',{key:cellIndex,staticClass:"epc-table-cell",class:{
        'section-name-cell': row.length === 1,
        'article-cell': row.length === _vm.maxCellQty && cellIndex === 0,
        'description-cell': row.length === _vm.maxCellQty && cellIndex === 1,
        'price-cell': row.length === _vm.maxCellQty && cellIndex === 2
      },attrs:{"colspan":row.length === 1 ? _vm.maxCellQty : false}},[_c('div',{staticClass:"epc-table-cell-content",domProps:{"innerHTML":_vm._s(_vm.prepareCellText(cell, cellIndex, row, rowIndex))}})])}),0)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }